import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IProfile } from '../models/account';
import { CoreStore } from '../../core/state/core.store';
import { joinApiUrl } from '../../core/config/api-url';

@Injectable({
  providedIn: 'root',
})
export class InfoProfile {
  private readonly _http = inject(HttpClient);
  private readonly _store = inject(CoreStore);

  infoProfile(): Observable<IProfile> {
    return this._http.get<IProfile>(
      joinApiUrl(this._store.userManagementBaseUrl(), this._store.endpoints().auth.info),
    );
  }
}
